import { Criteria, PromoMetaobject } from './metaobjects.types'

export function checkConditions(conditions: PromoMetaobject, criteria: Criteria): boolean {
  const { tags = [], products = [], collections = [] } = criteria

  // Always check date conditions first
  const now = Date.now()

  if (conditions?.start_date) {
    const startDate = new Date(conditions.start_date)
    if (now < startDate.getTime()) {
      return false
    }
  }

  if (conditions?.end_date) {
    const endDate = new Date(conditions.end_date)
    if (now >= endDate.getTime()) {
      return false
    }
  }

  // Check if any selector conditions are specified
  const hasTagConditions = conditions?.tags && conditions.tags.length > 0
  const hasProductConditions = conditions?.products && conditions.products.length > 0
  const hasCollectionConditions = conditions?.collections && conditions.collections.length > 0
  // If no selector conditions are specified, return true (only date constraints apply)
  if (!hasTagConditions && !hasProductConditions && !hasCollectionConditions) {
    return true
  }

  // Check tags if specified
  if (hasTagConditions && conditions.tags) {
    const match = conditions.tags.some(conditionTag =>
      tags.some(criteriaTag => conditionTag === criteriaTag)
    )
    if (match) return true
  }

  // Check products if specified
  if (hasProductConditions && conditions.products) {
    const match = conditions.products.some(conditionProduct =>
      products.some(criteriaProduct => conditionProduct === criteriaProduct)
    )
    if (match) return true
  }

  // Check collections if specified
  if (hasCollectionConditions && conditions.collections) {
    const match = conditions.collections.some(conditionCollection =>
      collections.some(criteriaCollection => conditionCollection === criteriaCollection)
    )
    if (match) return true
  }

  return false
}
